import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Form, FormControl, Validators } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@Component({
  selector: 'huge-monorepo-teltonika-ssh-log-in-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-ssh-log-in-modal.component.html',
  styleUrl: './teltonika-ssh-log-in-modal.component.scss',
})
export class TeltonikaSshLogInModalComponent {
  address: string | null;
  username: FormControl = new FormControl("root", Validators.required);
  password: FormControl = new FormControl("");

  constructor(
    public dialogRef: MatDialogRef<TeltonikaSshLogInModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.address = data.address;

  }

  closeDialog(submit: boolean): void {
    if (!submit) {
      this.dialogRef.close(null);
      return;
    } else {
      if (this.username.valid) {
        this.dialogRef.close({ username: this.username.value, password: this.password.value });
      } else {
        this.username.markAsTouched();
      }
    }
  }
}
